/* events */
export const DELETE_EVENT = "DELETE_EVENT"
export const DELETE_EVENT_SUCCESS = "DELETE_EVENT_SUCCESS"
export const DELETE_EVENT_ERROR = "DELETE_EVENT_ERROR"
export const DELETE_EVENT_CLEAN = "DELETE_EVENT_CLEAN"
